<as-split unit="pixel"
          direction="horizontal"
          [gutterSize]="7"
          gutterAriaLabel="divider"
          (dragEnd)="onSplitDragEnds($event)"
          #split="asSplit">
  <div *asSplitGutter
       class="custom-settings-area-gutter">
    <div asSplitGutterDragHandle
         class="custom-settings-area-gutter"></div>
  </div>
  <as-split-area [minSize]="splitterLeftContainerMinSize" [size]="100">
    <div class="ai-splitter-left-container">
      <ng-container *ngIf="activeProjectId; else noActiveProjectTemplate">
        <div class="rappider-ai-assistant">

          <!-- AI Start Component - Show when no messages -->
          <div class="ai-start-container"
               [@slideInOut]="showAiStart ? 'in' : 'out'"
               [hidden]="!showAiStart">
            <rappider-ai-start
              [config]="aiStartConfig"
              [isLoading]="aiCallInProgress"
              [editingModelName]="editingModelName"
              [showExamplePrompts]="showExamplePrompts"
              [examplePrompts]="examplePrompts"
              (startClicked)="onAiStartClicked($event)">
            </rappider-ai-start>
          </div>

          <!-- Chat Messages - Show when messages exist -->
          <div class="ai-chat-container"
               [@fadeInUp]="!showAiStart ? 'in' : 'out'"
               [hidden]="showAiStart">
            <div class="ai-assistant-scrolling-content">
              <rappider-chat-messages #chatMessagesComponent
                                      [messages]="messages"
                                      [senderAvatar]="senderAvatar"
                                      [receiverAvatar]="receiverAvatar"
                                      [isTyping]="isTyping"
                                      [sendButtonDisabled]="aiCallInProgress"
                                      [sendButtonDisabled]="isTyping && !activeProjectId"
                                      (responseAction)="onResponseAction($event)"
                                      (splitterToggleRequested)="onSplitterToggleRequested($event)"
                                      (revertRequested)="onRevertRequested($event)"></rappider-chat-messages>
            </div><!-- END OF SCROLLING AREA -->

            <div class="rappider-ai-chat-input-container">
              <rappider-chat-input [isAiInProgress]="aiCallInProgress"
                                   [displayMessageNavigationButtons]="false"
                                   (messageSent)="sendMessageToRapider($event.message, $event.files)"
                                   (fileUploadButtonClicked)="onFileUploadButtonClicked()"></rappider-chat-input>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #noActiveProjectTemplate>
        <div class="rappider-ai-assistant no-active-project">
          <h5>No active project. Please select a project for ai assistant.</h5>
        </div>
      </ng-template>
    </div>
  </as-split-area>
  <as-split-area [size]="splitterRightContainerSize">
    <!--  ai-splitter-toggle-button - Expand -->
    <div class="ai-splitter-right-container-toggle-button"
         nz-tooltip
         nzTooltipPlacement="right"
         [nzTooltipTitle]="splitterRightContainerSize > 0 ? 'Collapse Right Panel' : 'Expand Right Panel'"
         [ngClass]="{'collapsed': splitterRightContainerSize === 0}"
         (click)="onToggleSplitterRightContainer()">
      <a class="ai-splitter-toggle-button">
        <i [class]="splitterRightContainerSize > 0 ? 'fa-regular fa-angle-right ' : 'fa-regular fa-angle-left'"></i>
      </a>
    </div>
    <div class="ai-splitter-right-container">
      <div class="canvas-container">
        <rappider-ai-canvas-renderer
          [canvasKey]="aiFunctionId"
          [selectedProjectModelId]="selectedProjectModelId"
          [componentDefinitionId]="componentDefinitionId">
        </rappider-ai-canvas-renderer>
      </div>
    </div>
  </as-split-area>
</as-split>
